import { motion } from "framer-motion";
import { PRODUCTS_PROCESS } from "@/data/content";

export const ProductsProcess = () => (
  <section data-testid="products-process-section" className="bg-surfaceLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="max-w-2xl lg:mx-auto lg:text-center">
        <h2
          data-testid="products-process-headline"
          className="font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:text-[41px]"
        >
          From power class
          <br className="lg:hidden" /> to project
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:mt-14 lg:grid-cols-4 lg:gap-8">
        {PRODUCTS_PROCESS.map((step, index) => (
          <motion.div
            key={step.n}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5, delay: index * 0.08 }}
            data-testid={`products-process-step-${step.n}`}
            className="border-t-2 border-teal/20 pt-6"
          >
            <span className="font-mono text-sm text-teal">{step.n}</span>
            <h3
              data-testid={`products-process-step-title-${step.n}`}
              className="mt-2 font-heading text-base font-semibold text-ink"
            >
              {step.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-inkSoft">{step.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
